import Vue from 'vue'
import VueFileAgent from 'vue-file-agent'
// eslint-disable-next-line
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';

Vue.use(VueFileAgent)
